import { formatDateTime } from '@pickleballinc/lib/format-dates';
import { ProgressBar } from '@pickleballinc/react-ui';
import { useState } from 'react';

import { PreviusMatchesModal } from '@/modules/results/match/PreviusMatchesModal';
import { PreviusMatchesModalTeamOne } from '@/modules/results/match/PreviusMatchesModalTeamOne';
import { PreviusMatchesModalTeamTwo } from '@/modules/results/match/PreviusMatchesModalTeamTwo';
import { H2HStats } from '@/modules/results/types';

interface Player {
  name: string;
  uuid: string;
  teamUuid: string;
}

interface MatchH2HProps {
  playerList: Player[];
  blt?: string;
  formatTitle: string;
  matchH2HData: H2HStats;
  date: string;
  datePlaned: string;
  matchStatus: number;
  PPAOnly: boolean;
  setPPAOnly: React.Dispatch<React.SetStateAction<boolean>>;
  isProEvent: boolean;
  pbracketsURL?: string;
}

const H2HButtons = [
  { label: 'PPA', value: true },
  { label: 'Overall', value: false },
];

const MatchH2H = ({
  matchH2HData,
  playerList,
  formatTitle,
  date,
  datePlaned,
  matchStatus,
  PPAOnly,
  setPPAOnly,
  isProEvent,
  pbracketsURL,
}: MatchH2HProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [isModalOpen3, setIsModalOpen3] = useState(false);

  const teamOnePlayerOneName = matchH2HData?.team_one_player_one_full_name;
  const teamOnePlayerTwoName = matchH2HData?.team_one_player_two_full_name;
  const teamTwoPlayerOneName = matchH2HData?.team_two_player_one_full_name;
  const teamTwoPlayerTwoName = matchH2HData?.team_two_player_two_full_name;
  // const teamOnePlayerOneAge = matchH2HData?.team_one_player_one_age;
  // const teamOnePlayerTwoAge = matchH2HData?.team_one_player_two_age;
  // const teamTwoPlayerOneAge = matchH2HData?.team_two_player_one_year_borned;
  // const teamTwoPlayerTwoAge = matchH2HData?.team_two_player_two_year_borned;
  // const teamOnePlayerOneCity = matchH2HData?.team_one_player_one_city;
  // const teamOnePlayerTwoCity = matchH2HData?.team_one_player_two_city;
  // const teamTwoPlayerOneCity = matchH2HData?.team_two_player_one_city;
  // const teamTwoPlayerTwoCity = matchH2HData?.team_two_player_two_city;
  // const teamOnePlayerOneState = matchH2HData?.team_one_player_one_state_abbreviation;
  // const teamOnePlayerTwoState = matchH2HData?.team_one_player_two_state_abbreviation;
  // const teamTwoPlayerOneState = matchH2HData?.team_two_player_one_state_abbreviation;
  // const teamTwoPlayerTwoState = matchH2HData?.team_two_player_two_state_abbreviation;
  // const teamOnePlayerOneCountry = matchH2HData?.team_one_player_one_country_abbrviation;
  // const teamOnePlayerTwoCountry = matchH2HData?.team_one_player_two_country_abbrviation;
  // const teamTwoPlayerOneCountry = matchH2HData?.team_two_player_one_country_abbrviation;
  // const teamTwoPlayerTwoCountry = matchH2HData?.team_two_player_two_country_abbrviation;
  const team1Wins = matchH2HData.team_one_wins_against_team_two;
  const team2Wins = matchH2HData.team_two_wins_against_team_one;
  const isSingle = teamOnePlayerTwoName === '' || teamTwoPlayerTwoName === '' ? true : false;

  function calculateWins(wins: number, losts: number) {
    if (wins + losts === 0) {
      return 'No played matches';
    }
    const sum = wins + losts;
    const result = (wins / sum) * 100;
    return parseFloat(result.toFixed(2));
  }

  // function calculateAge(year: number) {
  // 	const currentYear = new Date().getFullYear();
  // 	const age = currentYear - year;
  // 	return age;
  // }

  function calculateMatchesNumber() {
    const sumMaches = team1Wins + team2Wins;
    return sumMaches;
  }

  function calculateWinsPerTeam(firstArgWins: number, secondArgWins: number): number {
    const sum: number = firstArgWins + secondArgWins;
    if (sum === 0) return sum;

    const result: number = (firstArgWins / sum) * 100;
    return parseFloat(result.toFixed(2));
  }

  const openModalHandler = (type: string, winVal: string | number) => {
    if (winVal !== 'No played matches') {
      if (type === 'modal2') {
        setIsModalOpen2(true);
      }
      if (type === 'modal3') {
        setIsModalOpen3(true);
      }
    }
  };
  const openModalHistoryHandler = () => {
    const playedMatches = calculateMatchesNumber();
    if (playedMatches !== 0) {
      setIsModalOpen(true);
    }
  };

  const win1 = matchH2HData.team_one_total_wins > 1 ? 'wins' : 'win';
  const win2 = matchH2HData.team_two_total_wins > 1 ? 'wins' : 'win';
  const lost1 = matchH2HData.team_one_total_lost > 1 ? 'losses' : 'loss';
  const lost2 = matchH2HData.team_two_total_lost > 1 ? 'losses' : 'loss';
  const isPlayedMatches1 =
    matchH2HData.team_one_total_wins > 0 || matchH2HData.team_one_total_lost > 0 ? true : false;
  const isPlayedMatches2 =
    matchH2HData.team_two_total_wins > 0 || matchH2HData.team_two_total_lost > 0 ? true : false;

  return (
    <div className='w-full'>
      {isProEvent ? (
        <ul className='flex w-full justify-center gap-x-3'>
          {H2HButtons.map((button) => (
            <li
              key={`h2h-button-${button.value}`}
              className={`min-w-[80px] cursor-pointer rounded-md border border-gray-300 p-2 text-center md:min-w-[160px] ${
                PPAOnly === button.value ? 'bg-experiment text-white' : 'bg-white text-black'
              }`}
              onClick={() => setPPAOnly(button.value)}
            >
              {button.label}
            </li>
          ))}
        </ul>
      ) : null}
      <div className='mt-4 w-full rounded-lg border bg-white'>
        <div>
          <div className='w-full px-3 sm:m-auto sm:w-2/3'>
            <div>
              <div className='flex min-h-[180px] border-b py-5'>
                <div className='flex flex-1 flex-col items-center justify-center'>
                  <div className='mb-4 flex flex-col items-center justify-center'>
                    <div>
                      <span className='font-bold'>
                        {matchH2HData.team_one_wins_against_team_two}
                      </span>
                    </div>
                    <div className='text-xs'>
                      <span>{calculateWinsPerTeam(team1Wins, team2Wins)} % wins</span>
                    </div>
                  </div>
                </div>
                <div className='flex flex-1 flex-col items-center justify-center text-center'>
                  {matchStatus === 4 && date ? (
                    <div className='font-bold'>
                      {formatDateTime(date, { includeWeekday: true })}
                    </div>
                  ) : null}
                  <div className='text-md font-bold sm:text-xl'>{calculateMatchesNumber()}</div>
                  <div className='mb-3 text-xs sm:text-base'>Matches played</div>
                  <ProgressBar
                    progressColor='#59a65c'
                    progress={calculateWinsPerTeam(team1Wins, team2Wins)}
                  />
                  <div
                    onClick={() => openModalHistoryHandler()}
                    className={`${calculateMatchesNumber() !== 0 ? 'cursor-pointer text-experiment' : ''} mt-3 text-xs sm:text-base`}
                  >
                    <span>H2H Detail</span>
                  </div>
                  <div className='mb-4 text-center text-xs text-gray-500'>
                    <span>H2H stats are based on the time this match was played</span>
                  </div>
                </div>
                <div className='flex flex-1 flex-col items-center justify-center'>
                  <div className='mb-4 flex flex-col items-center justify-center'>
                    <div>
                      <span className='font-bold'>
                        {matchH2HData.team_two_wins_against_team_one}
                      </span>
                    </div>
                    <div className='text-xs'>
                      <span>{calculateWinsPerTeam(team2Wins, team1Wins)} % wins</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className='flex min-h-[130px] flex-wrap border-b sm:flex-nowrap'>
                <button
                  onClick={() =>
                    openModalHandler(
                      'modal2',
                      calculateWins(
                        matchH2HData.team_one_total_wins,
                        matchH2HData.team_one_total_lost
                      )
                    )
                  }
                  disabled={!isPlayedMatches1}
                  className='order-2 flex w-1/2 flex-col items-center justify-center sm:order-1 sm:w-1/3'
                >
                  <div className='flex flex-col items-center justify-center text-sm'>
                    <div>
                      <div>
                        <span
                          className={`${isPlayedMatches1 ? 'cursor-pointer font-bold text-experiment' : 'text-gray-900'}`}
                        >
                          {matchH2HData.team_one_total_wins}
                        </span>
                        <span> {win1}</span>
                      </div>
                      <div>
                        <span
                          className={`${isPlayedMatches1 ? 'font-bold text-experiment' : 'text-gray-900'}`}
                        >
                          {matchH2HData.team_one_total_lost}
                        </span>
                        <span> {lost1}</span>
                      </div>
                    </div>

                    {calculateWins(
                      matchH2HData.team_one_total_wins,
                      matchH2HData.team_one_total_lost
                    ) === 'No played matches' ? (
                      <div className='text-xs'>
                        <span>
                          {calculateWins(
                            matchH2HData.team_one_total_wins,
                            matchH2HData.team_one_total_lost
                          )}
                        </span>
                      </div>
                    ) : (
                      <div className='text-xs'>
                        <span>
                          {calculateWins(
                            matchH2HData.team_one_total_wins,
                            matchH2HData.team_one_total_lost
                          )}
                          %
                        </span>
                        <span> matches won</span>
                      </div>
                    )}
                  </div>
                </button>
                <div className='order-1 flex w-full flex-col items-center justify-center text-center sm:order-2 sm:w-1/3'>
                  {isSingle ? (
                    <>
                      <h5 className='text-xs sm:text-base'>W/L Singles</h5>
                      <h6 className='text-xs text-gray-500'>
                        This is the wins and losses when playing against all opponents
                      </h6>
                    </>
                  ) : (
                    <>
                      <h5 className='text-xs sm:text-base'>W/L Together</h5>
                      <h6 className='text-xs text-gray-500'>
                        This is the wins and losses when playing together as a team against all
                        opponents
                      </h6>
                    </>
                  )}
                </div>
                <button
                  onClick={() =>
                    openModalHandler(
                      'modal3',
                      calculateWins(
                        matchH2HData.team_two_total_wins,
                        matchH2HData.team_two_total_lost
                      )
                    )
                  }
                  disabled={!isPlayedMatches2}
                  className='order-3 flex w-1/2 flex-col items-center justify-center sm:w-1/3'
                >
                  <div className='flex flex-col items-center justify-center text-sm'>
                    <div>
                      <div>
                        <span
                          className={`${isPlayedMatches2 ? 'cursor-pointer font-bold text-experiment' : 'text-gray-900'}`}
                        >
                          {matchH2HData.team_two_total_wins}
                        </span>
                        <span> {win2}</span>
                      </div>
                      <div>
                        <span
                          className={`${isPlayedMatches2 ? 'font-bold text-experiment' : 'text-gray-900'}`}
                        >
                          {matchH2HData.team_two_total_lost}
                        </span>
                        <span> {lost2}</span>
                      </div>
                    </div>
                    {calculateWins(
                      matchH2HData.team_two_total_wins,
                      matchH2HData.team_two_total_lost
                    ) === 'No played matches' ? (
                      <div className='text-xs'>
                        <span>
                          {calculateWins(
                            matchH2HData.team_two_total_wins,
                            matchH2HData.team_two_total_lost
                          )}
                        </span>
                      </div>
                    ) : (
                      <div className='text-xs'>
                        <span>
                          {calculateWins(
                            matchH2HData.team_two_total_wins,
                            matchH2HData.team_two_total_lost
                          )}
                          %
                        </span>
                        <span> matches won</span>
                      </div>
                    )}
                  </div>
                </button>
              </div>
              {/* <div className="flex min-h-[110px] flex-wrap border-b sm:flex-nowrap">
								<div className="order-2 flex w-1/2 flex-col items-center justify-center sm:order-1 sm:w-1/3">
									<div className="flex flex-col items-center justify-center">
										<div>
											 <span className="font-bold">{matchH2HData?.team_one_rating_current?.toFixed(3) ?? 'N/A'}</span> 
										</div>
										<div className="flex flex-col items-center gap-0 text-xs sm:flex-row sm:gap-1">
											<span>{teamOnePlayerOneName}</span>
											{teamOnePlayerTwoName !== '' && (
												<span>
													<span className="hidden items-center sm:inline-flex">&</span> {teamOnePlayerTwoName}
												</span>
											)}
										</div>
									</div>
								</div>
								<div className="order-1 flex w-full items-center justify-center text-center sm:order-2 sm:w-1/3">
									{isSingle ? (
										<h5 className="text-xs sm:text-base">Player Rating</h5>
									) : (
										<h5 className="text-xs sm:text-base">Team Rating</h5>
									)}
								</div>
								<div className="order-3 flex w-1/2 flex-col items-center justify-center sm:w-1/3">
									<div className="flex flex-col items-center justify-center">
										<div>
											 <span className="font-bold">{matchH2HData?.team_two_rating_current?.toFixed(3) ?? 'N/A'}</span>
										</div>
										<div className="flex flex-col items-center gap-0 text-xs sm:flex-row sm:gap-1">
											<span>{teamTwoPlayerOneName}</span>
											{teamTwoPlayerTwoName !== '' && (
												<span>
													<span className="hidden items-center sm:inline-flex">&</span> {teamTwoPlayerTwoName}
												</span>
											)}
										</div>
									</div>
								</div>
							</div> */}
              {/* <div className="flex min-h-[110px] flex-wrap border-b text-center sm:flex-nowrap">
								<div className="order-2 flex w-1/2 flex-col items-center justify-center sm:order-1 sm:w-1/3">
									<div className="flex flex-col items-center justify-center">
										<div className="flex flex-col text-xs sm:text-base">
											<div>
												<span>{teamOnePlayerOneName}</span>{' '}
												<span className="font-bold ">{calculateAge(teamOnePlayerOneAge)}</span>
											</div>
											{teamOnePlayerTwoAge ? (
												<div>
													<span>{teamOnePlayerTwoName} </span>
													<span className="font-bold ">{calculateAge(teamOnePlayerTwoAge)}</span>
												</div>
											) : null}
										</div>
									</div>
								</div>
								<div className="order-1 flex w-full flex-col items-center justify-center text-center sm:order-2 sm:w-1/3">
									<h5 className=" text-xs sm:text-base">Ages</h5>
								</div>
								<div className="order-3 flex w-1/2 flex-col items-center justify-center sm:w-1/3">
									<div className="flex flex-col items-center justify-center">
										<div className="flex flex-col text-xs sm:text-base">
											<div>
												<span>{teamTwoPlayerOneName}</span>{' '}
												<span className="font-bold ">{calculateAge(teamTwoPlayerOneAge)}</span>
											</div>
											{teamTwoPlayerTwoAge ? (
												<div>
													<span>{teamTwoPlayerTwoName}</span>{' '}
													<span className="font-bold ">{calculateAge(teamTwoPlayerTwoAge)}</span>
												</div>
											) : null}
										</div>
									</div>
								</div>
							</div>
							<div className="flex min-h-[110px] flex-wrap text-center sm:flex-nowrap">
								<div className="order-2 flex w-1/2 flex-col items-center justify-center sm:order-1 sm:w-1/3">
									<div className="flex flex-col items-center justify-center">
										<div className="flex flex-col">
											<span className="text-xs sm:text-base">{teamOnePlayerOneCity}</span>
											<span className="text-xs sm:text-base">
												{teamOnePlayerOneState}, {teamOnePlayerOneCountry}
											</span>
										</div>
										{teamOnePlayerTwoCity !== '' && (
											<div className="flex flex-col">
												<span className="text-xs sm:text-base">{teamOnePlayerTwoCity}</span>
												<span className="text-xs sm:text-base">
													{teamOnePlayerTwoState}, {teamOnePlayerTwoCountry}
												</span>
											</div>
										)}
									</div>
								</div>
								<div className="order-1 flex w-full flex-col items-center justify-center text-center sm:order-1 sm:w-1/3">
									<h5 className="text-xs sm:text-base">Location</h5>
								</div>
								<div className="order-3 flex w-1/2 flex-col items-center justify-center sm:w-1/3">
									<div className="flex flex-col items-center">
										<div className="flex flex-col">
											<span className="text-xs  sm:text-base">{teamTwoPlayerOneCity},</span>
											<span className="text-xs sm:text-base">
												{teamTwoPlayerOneState}, {teamTwoPlayerOneCountry}
											</span>
										</div>
										{teamTwoPlayerTwoCity !== '' && (
											<div className="flex flex-col">
												<span className="text-xs  sm:text-base">{teamTwoPlayerTwoCity}</span>

												<span className="text-xs sm:text-base">
													{teamTwoPlayerTwoState}, {teamTwoPlayerTwoCountry}
												</span>
											</div>
										)}
									</div>
								</div>
							</div> */}
            </div>
          </div>
        </div>
      </div>
      <PreviusMatchesModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        data={matchH2HData}
        calculateWinsTeamOne={calculateWinsPerTeam(team1Wins, team2Wins)}
        calculateWinsTeamTwo={calculateWinsPerTeam(team2Wins, team1Wins)}
        calculateMatchesNumber={calculateMatchesNumber()}
        teamOnePlayerOneName={teamOnePlayerOneName}
        teamOnePlayerTwoName={teamOnePlayerTwoName}
        teamTwoPlayerOneName={teamTwoPlayerOneName}
        teamTwoPlayerTwoName={teamTwoPlayerTwoName}
        isHistory
        pbracketsURL={pbracketsURL}
      />
      <PreviusMatchesModalTeamOne
        isOpen={isModalOpen2}
        onClose={() => setIsModalOpen2(false)}
        calculateWinsTeam={matchH2HData.team_one_total_wins}
        calculateLostTeam={matchH2HData.team_one_total_lost}
        calculateMatchesNumber={calculateWins(
          matchH2HData.team_one_total_wins,
          matchH2HData.team_one_total_lost
        )}
        teamOnePlayerOneName={teamOnePlayerOneName}
        teamOnePlayerTwoName={teamOnePlayerTwoName}
        teamTwoPlayerOneName={teamTwoPlayerOneName}
        teamTwoPlayerTwoName={teamTwoPlayerTwoName}
        isHistory
        playerList={playerList}
        team={1}
        formatTitle={formatTitle}
        date={datePlaned}
        pbracketsURL={pbracketsURL}
      />
      <PreviusMatchesModalTeamTwo
        isOpen={isModalOpen3}
        onClose={() => setIsModalOpen3(false)}
        calculateWinsTeam={matchH2HData.team_two_total_wins}
        calculateLostTeam={matchH2HData.team_two_total_lost}
        calculateMatchesNumber={calculateWins(
          matchH2HData.team_two_total_wins,
          matchH2HData.team_two_total_lost
        )}
        teamOnePlayerOneName={teamOnePlayerOneName}
        teamOnePlayerTwoName={teamOnePlayerTwoName}
        teamTwoPlayerOneName={teamTwoPlayerOneName}
        teamTwoPlayerTwoName={teamTwoPlayerTwoName}
        isHistory
        playerList={playerList}
        team={2}
        formatTitle={formatTitle}
        date={datePlaned}
        pbracketsURL={pbracketsURL}
      />
    </div>
  );
};

export default MatchH2H;
